import createReport from '../../../api/createReport'
import updateReport from '../../../api/updateReport'
import Report from '../../types/api/report'

export default async function onSave<T>(
    report: Report,
    changed: T,
    set: (changed: T, report: Report) => Report
): Promise<Report> {
    const uid = report.uid || 'new'
    const newReport = set(changed, report)
    const request = uid === 'new' ? createReport : updateReport

    return new Promise(resolve => {
        request(newReport)
            .then(request => request.config)
            .then(config => resolve(config))
    })
}
